var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PHelpModal',{attrs:{"title":_vm.title,"intro":_vm.intro,"steps":_vm.steps,"notes":_vm.notes}})}
var staticRenderFns = []

export { render, staticRenderFns }